var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('SearchObject', {
    ref: "search",
    attrs: {
      "additional-params": Object.assign({
        ordering: 'name'
      }, _vm.additionalParams),
      "allow-create": _vm.allowCreate,
      "autofocus": _vm.autofocus,
      "base-url": _vm.baseUrl,
      "create-label": _vm.$translate('create_a_product'),
      "disabled": _vm.disabled,
      "hide-details": _vm.hideDetails,
      "error-messages": _vm.errorMessages,
      "item-text": _vm.itemText,
      "hide-label": _vm.hideLabel,
      "placeholder": _vm.resolvedPlaceholder,
      "label": _vm.hideLabel ? '' : _vm.label || _vm.$translate('select_product'),
      "readonly": _vm.readonly,
      "required": _vm.required,
      "value": _vm.value,
      "initial-item": _vm.initialItem,
      "dense": _vm.dense,
      "outlined": _vm.outlined
    },
    on: {
      "create": _vm.createProduct,
      "input": function input($event) {
        return _vm.$emit('input', $event);
      },
      "select": function select($event) {
        return _vm.$emit('select', $event);
      }
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('div', [_vm.displayOwner && item.owner_data && item.owner_data.name ? _c('div', {
          staticClass: "text-caption text--secondary"
        }, [_vm._v(_vm._s(item.owner_data.name))]) : _vm._e(), _c('ProductName', {
          staticClass: "my-1 text-body-3",
          attrs: {
            "type": "providerproduct",
            "product": item,
            "display-code": true,
            "inline-code": true
          }
        })], 1)];
      }
    }])
  });

}
var staticRenderFns = []

export { render, staticRenderFns }